import { isHotelPackage } from 'lib/offer/offerTypes'

export function mapRoomPackage<T>(
  roomPackage: App.Property.Room | App.HotelPackage | App.BedbankPackage,
  mapPropertyRoom: (room: App.Property.Room) => T,
  mapHotelPackage: (hotelPackage: App.HotelPackage) => T,
  mapBedbankPackage: (bedbankPackage: App.BedbankPackage) => T,
): T {
  // This isn't the most meaningful discriminator, but it does the job.
  if ('defaultOrder' in roomPackage) {
    return mapPropertyRoom(roomPackage)
  }
  if (isHotelPackage(roomPackage)) {
    return mapHotelPackage(roomPackage)
  }
  return mapBedbankPackage(roomPackage)
}
